/**
 * Base64 to File Utility
 */

/**
 * Convert a base64 string to a File object with actual byte content.
 */
export const base64ToFile = (base64: string, filename: string, mimeType: string): File => {
    // Handle data URI scheme if present
    const base64Data = base64.includes(',') ? base64.split(',')[1] : base64;

    const byteString = atob(base64Data);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new File([ab], filename, { type: mimeType });
};
